import Axios from 'axios'
import config from '../app.config'

export var kindsService
export default kindsService = {
	getKinds,
	showKinds,
	updateKinds,
	createKinds,
	deleteKinds,
	getListKinds
}
async function getKinds(payload) {
	return await Axios.get(`${config.LOCAL_API_URL}/kinds`, { params: payload })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
async function showKinds(id) {
	return await Axios.get(`${config.LOCAL_API_URL}/kinds/` + id)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function updateKinds(data) {
	return await Axios.put(`${config.LOCAL_API_URL}/kinds/` + data.id, data)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function deleteKinds(params) {
	return await Axios.delete(`${config.LOCAL_API_URL}/kinds`, { data: params })
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}
async function createKinds(params) {
	return await Axios.post(`${config.LOCAL_API_URL}/kinds`, params)
		.then((response) => {
			if (response.data.success || response.data.status) return Promise.resolve(response.data)
			else return Promise.reject(response.data)
		})
		.catch((error) => {
			return Promise.reject(error.response.data)
		})
}

async function getListKinds(type = 0) {
	return await Axios.get(`${config.LOCAL_API_URL}/getListKinds/${type}`)
		.then((response) => {
			if (response.data) {
				return Promise.resolve(response.data)
			} else {
				return Promise.reject(response)
			}
		})
		.catch((error) => {
			return Promise.reject(error)
		})
}
